const CURRENCY_LIST = [
  { id: 1, code: "USD", name: "USD" },
  { id: 2, code: "EUR", name: "EUR" },
  // Add more currencies as needed
];
//
export default CURRENCY_LIST;
